 
import _ from 'underscore'
import service from '../service/session'
import CONSTANT from '../constant/session'

const setSession = ({ commit, state }, options) => {
  return new Promise((resolve, reject) => {
    return service.setSession(options).then(data => {
      return resolve()
    }, e => {
      reject(e)
    })
  })
}

export default {
  setSession,
}
